import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

export const CaseStudySection = ({ caseStudy }) => (
  <section id="case-study" className="py-12 md:py-16 lg:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Featured Case Study</h2>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto">
          Real-world success in achieving compliance and security
        </p>
      </div>
      <Card className="border-slate-200 max-w-4xl mx-auto">
        <CardHeader>
          {caseStudy.industry && (
            <div className="flex items-center justify-between mb-4">
              <Badge variant="outline" className="border-[#105EFF] text-[#105EFF]">{caseStudy.industry}</Badge>
            </div>
          )}
          <CardTitle className="text-3xl text-slate-900">{caseStudy.title}</CardTitle>
          <CardDescription className="text-lg">{caseStudy.client}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h4 className="font-semibold text-slate-900 mb-2">Challenge</h4>
            <p className="text-slate-700">{caseStudy.challenge}</p>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-2">Solution</h4>
            <p className="text-slate-700">{caseStudy.solution}</p>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-4">Key Metrics</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {caseStudy.metrics.map((metric) => (
                <div key={metric.label} className="bg-slate-50 p-4 rounded-lg border border-slate-200">
                  <div className="text-3xl font-bold text-[#105EFF] mb-1">{metric.value}</div>
                  <div className="text-sm text-slate-600">{metric.description}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-2">Results</h4>
            <ul className="space-y-2">
              {caseStudy.results.map((result) => (
                <li key={result} className="flex items-start space-x-2">
                  <CheckCircle className="h-5 w-5 text-[#105EFF] flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{result}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-[#105EFF]">
            <p className="text-slate-700 italic mb-2">"{caseStudy.testimonial}"</p>
            <p className="text-slate-600 text-sm">— {caseStudy.clientName}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  </section>
);
